import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const updateFrequenciesSlice = createSlice({
  name: "updateFrequencies",
  initialState,
  reducers: {
    fetchUpdateFrequenciesStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchUpdateFrequenciesSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchUpdateFrequenciesFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetUpdateFrequenciesState(state) {
      state.data = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  fetchUpdateFrequenciesStart,
  fetchUpdateFrequenciesSuccess,
  fetchUpdateFrequenciesFailure,
  resetUpdateFrequenciesState,
} = updateFrequenciesSlice.actions;
export default updateFrequenciesSlice.reducer;
